export default __webpack_public_path__ + "static/media/traffic_light_none.4fe6f41f.png";